export enum FilterSubject {
  ELEMENT = 'element',
  NAME = 'name',
  DESCRIPTION = 'description',
  PROPERTY = 'property',
  COMMENT = 'comment'
}

export enum FilterVerb {
  CONTAINS = 'contains',
  STARTS_WITH = 'starts with',
  ENDS_WITH = 'ends with',
  EQUALS = 'equals',
  DOES_NOT_CONTAIN = 'does not contain',
  DOES_NOT_START_WITH = 'does not start with',
  DOES_NOT_END_WITH = 'does not end with',
  DOES_NOT_EQUAL = 'does not equal'
}

export enum FilterMatchType {
  MATCH = 'match',
  DO_NOT_MATCH = 'do not match'
}

export enum FilterConditionType {
  ALL_CONDITIONS = 'all conditions',
  ANY_CONDITION = 'any condition'
}

export enum FilterActionType {
  ARE_DIMMED = 'are dimmed',
  ARE_HIDDEN = 'are hidden'
}

export interface FilterConditionDto {
  subject: FilterSubject;
  verb: FilterVerb;
  object: string;
  propertyName?: string; // Used when subject is 'property'
}

export interface FilterActionDto {
  matchType: FilterMatchType;
  conditionType: FilterConditionType;
  actionType: FilterActionType;
}

export interface FilterDto {
  id: string;
  name: string;
  description?: string;
  excludeFromReadOnly: boolean;
  isGlobal: boolean;
  conditions: FilterConditionDto[];
  action: FilterActionDto;
  mapId: string;
  updatedAt: Date;
}